import { Component, type OnInit } from "@angular/core";
import {
    AbstractControl,
    FormBuilder,
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { WtfAnimations } from "../../../../utils/others/core/animations";
import { environment } from "../../../../../environments/environment";
import { RecoveryRequestService } from "../../../../services/security/recovery-request.service";
import { IsValidToken } from "../../../../utils/interfaces/security/isvalidtoken.interface";
import { ValidationService } from "../../../../services/validation/validation.service";
import { ResetPassword } from "../../../../utils/interfaces/security/reset-password.interface";

@Component({
    templateUrl: "./reset-password.component.html",
    styleUrl: "./reset-password.component.scss",
    animations: WtfAnimations,
    providers: [ValidationService],
})
export class ResetPasswordComponent implements OnInit {
    public isTokenValid = false;
    public resetForm: FormGroup;
    public isWaiting = false;
    public policy = false;
    public hide = true;
    public hideConfirm = true;
    public hasError: boolean = false;
    public message: string;

    private token: string;
    private strongPasswordRegex: RegExp =
        /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!]).{8,}$/;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private fb: FormBuilder,
        private recoveryService: RecoveryRequestService,
        private validationService: ValidationService
    ) {}

    isControlValid(form: FormGroup, field: string) {
        return this.validationService.isValidField(form, field);
    }

    getErrorMessage(form: FormGroup, field: string, text: string) {
        return this.validationService.getErrorMessage(form, field, text);
    }

    showPolicy() {
        this.policy = true;
    }

    hidePolicy() {
        this.policy = false;
    }

    ngOnInit(): void {
        this.route.queryParamMap.subscribe((params) => {
            this.recoveryService
                .verifyToken(params.get("token"))
                .subscribe((res: IsValidToken) => {
                    this.token = params.get("token");
                    this.isTokenValid = res.isValid;
                });
        });

        this.buildForm();
    }

    private buildForm(): void {
        this.resetForm = this.fb.group(
            {
                password: [
                    "",
                    [
                        Validators.required,
                        Validators.pattern(this.strongPasswordRegex),
                    ],
                ],
                confirmPassword: ["", [Validators.required]],
            },
            { validators: this.passwordsMatchValidator() }
        );
    }
    private passwordsMatchValidator(): ValidatorFn {
        return (formGroup: AbstractControl): ValidationErrors | null => {
            const password = formGroup.get("password")?.value;
            const confirmPassword = formGroup.get("confirmPassword")?.value;

            if (password !== confirmPassword) {
                formGroup
                    .get("confirmPassword")
                    .setErrors({ notEqualPassword: true });
            } else {
                return null;
            }
        };
    }

    resetPassword() {
        const data: ResetPassword = {
            token: this.token,
            password: this.resetForm.value.password,
        };
        this.recoveryService.resetPassword(data).subscribe((res: any) => {
            if (res.status === "OK") {
                this.router.navigate(["/login"]);
            } else {
                this.hasError = true;
                this.message = res.message;

                setTimeout(() => {
                    this.hasError = false;
                }, 2000);
            }
        });
    }

    disableButton() {
        return this.resetForm.invalid;
    }
}
